module.exports = __webpack_public_path__ + "img/huracan.6ff53d93.png";